export const headerDict = {
  nav: {
    start: 'Start',
    about: 'O nas',
    offer: 'Oferta',
    cooperation: 'Współpraca',
    contact: 'Kontakt',
    jobs: 'Praca'
  },
  clientLogosText: 'Zaufali nam:'
};


// WEBPACK FOOTER //
// ./src/static_data/dictionary.js